import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import wor_clo_to_wat_haz_lev from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_haz_lev.png";
import wor_clo_to_wat_boa from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_boa.png";
import wor_clo_to_wat_cof_dam from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_cof.png";
import wor_clo_to_wat_div from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_div.png";
import wor_clo_to_wat_edg_pro from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_edg_pro.png";
import wor_clo_to_wat_fal_arr from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_fal_arr.png";
import wor_clo_to_wat_lif_rin from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_lif_rin.png";
import wor_clo_to_wat_per_flo_ves from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_pro_flo.png";
import wor_clo_to_wat_pon_cra from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_pon_cra.png";
import wor_clo_to_wat_saf_lin from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_saf_lin.png";
import wor_clo_to_wat_wor_pla from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_wor_pla.png";
import wor_clo_to_wat_dre from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_dre.png";
import wor_clo_to_wat_sit_spe_met from "../img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_sit_spe_met.png";
const json = {
    icon: wor_clo_to_wat_haz_lev,
    name: "Working Close To Water",
    text: "",
    icons: {
        wor_clo_to_wat_edg_pro: {
            name: "Edge Protection",
            icon: wor_clo_to_wat_edg_pro,
            text: (
                <ul>
                    <ListItem text="All edges, where there is a risk of operatives falling off must be protected by barriers, handrails, mid-rails, toe-boards etc." />
                    <ListItem text="All edges, where there is a risk of materials falling off must be protected by using scaffolding/ platforms." />
                </ul>
            )
        },
        wor_clo_to_wat_fal_arr: {
            name: "Fall Arrest & Rescue",
            icon: wor_clo_to_wat_fal_arr,
            text: (
                <ul>
                    <ListItem text="Cannot be used to replace safe working platforms or safety nets. (Fall restraint)." />
                    <ListItem text="Fall Arrest and Rescue equipment needs to be inspected regularly and visually before each use." />
                    <ListItem text="Operatives must be trained" />
                    <Li>
                        <Typography variant="title">
                            Should be used in connection with a rescue plan.
                            This plan must ensure the operative can be retrieved
                            as soon as possible after the fall and NOT wait on
                            emergency services response. There are 4 classes of
                            rescue, risk assessed for most suitable
                        </Typography>
                        <ol>
                            <ListItem text="Lowering a remote casualty" />
                            <ListItem text="Raising a remote casualty" />
                            <ListItem text="Self evacuation by descent" />
                            <ListItem text="Rescue another in descent (preferably avoided so that other complications are not introduced)" />
                        </ol>
                    </Li>
                    <ListItem text="The rescuer should not endanger themselves when carrying out a rescue procedure" />
                    <ListItem text="Will consist of a full-body harness (with webbing and padding), lanyard, shock absorber (if fall arrest rather than fall restraint) and suitable anchor/ tie off point." />
                    <ListItem text="The anchor must be capable of supporting the load in the required direction." />
                    <ListItem text="Ensure proper tie off to anchor points, and re-check before commencing, irrespective of how short the task is going to be." />
                    <ListItem text="The harness must be worn fully secured, comfortable but snug and positioned correctly." />
                    <ListItem text="All connection systems must have double action, self closing, self locking snap hooks to reduce the possibility of roll out" />
                    <ListItem text="Use safety helmets (With chin straps) instead of hard hats." />
                </ul>
            )
        },
        wor_clo_to_wat_wor_pla: {
            name: "Working Platform",
            icon: wor_clo_to_wat_wor_pla,
            text: (
                <ul>
                    <ListItem text="This is a platform that prevents a worker from falling to a lower level, such as scaffolds, MEWPs etc." />
                    <ListItem text="It must be secure, stable and level" />
                    <ListItem text="The Safe Working Load must be displayed/known, and you are not permitted to overload the platform." />
                    <ListItem text="It must provide safe passage, be large enough to allow the safe use of equipment and materials" />
                    <ListItem text="It must be maintained free from trip hazards, or gaps through which persons or materials could fall, with toe boards and handrails." />
                    <ListItem text="You must maintain the platform in a tidy condition, free from debris." />
                </ul>
            )
        },
        wor_clo_to_wat_lif_rin: {
            name: "Life Ring",
            icon: wor_clo_to_wat_lif_rin,
            text: (
                <ul>
                    <ListItem text="Life rings must be located appropriately and have hauling lines/ or throwing lines securely attached. These lines must be of sufficient length for a rescue from the bank. All operatives on site need to be informed of these locations" />
                    <ListItem text="They should be inspected regularly (at least 1/ month for content, security and deterioration)" />
                </ul>
            )
        },
        wor_clo_to_wat_saf_lin: {
            name: "Safety Line/ Grab Line",
            icon: wor_clo_to_wat_saf_lin,
            text: (
                <ul>
                    <ListItem text="Workers working close the edge of water may have a safety line attached to them to allow for their quick retrieval." />
                    <ListItem text="Grab lines can be placed across shores or downstream to allow workers to self-rescue and pull themselves to safety" />
                </ul>
            )
        },
        wor_clo_to_wat_per_flo: {
            name: "Personal Floatation Vest",
            icon: wor_clo_to_wat_per_flo_ves,
            text: (
                <ul>
                    <ListItem text="Where the risk of drowning is greater than the risk of falling, a personal flotation device should be used instead of a harness. Other fall controls (instead of a harness) should still be used." />
                    <ListItem text="The floatation device must be stored and maintained in accordance with the manufacturer’s instructions" />
                    <ListItem text="The device must be checked by the wearer before each use, for signs of wear/ damage." />
                    <ListItem text="The device must be thoroughly examined every 12 months by a competent person and certified. The certificate must be available to the wearer." />
                </ul>
            )
        },
        wor_clo_to_wat_boa: {
            name: "Boat",
            icon: wor_clo_to_wat_boa,
            text: (
                <ul>
                    <ListItem text="If a boat has been identified as part of the rescue plan, ensure workers have access to it" />
                    <Li>
                        <Typography variant="title">
                            The boat should either
                        </Typography>
                        <ol>
                            <ListItem text="Remain tethered to the bank during rescue" />
                            <ListItem text="Be under the control of a competent person during rescue" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        wor_clo_to_wat_cof: {
            name: "Coffer Dam",
            icon: wor_clo_to_wat_cof_dam,
            text: (
                <ul>
                    <ListItem text="Any pumps must be regularly inspected for operation, fuel, and effectiveness" />
                    <ListItem text="Warning signals for evacuation of operatives in case of emergency shall be developed and communicated" />
                    <ListItem text="At least two means of rapid exit, with guardrails shall be provided." />
                    <ListItem text="Locations close to shipping channels shall be protected from vessels in transit" />
                </ul>
            )
        },
        wor_clo_to_wat_pon_cra: {
            name: "Pontoon & Crane",
            icon: wor_clo_to_wat_pon_cra,
            text: (
                <ul>
                    <ListItem text="All edges must have adequate protection" />
                    <ListItem text="Welfare arrangement need to be in place" />
                    <ListItem text="All equipment and materials must be secured." />
                    <ListItem text="The crane must be securely lashed to the pontoon (normally by lashing it’s tracks). The lashing must have the required safe working load." />
                    <ListItem text="At the end of the work shift the cranes jib should be lowered and also lashed to the pontoon" />
                </ul>
            )
        },
        wor_clo_to_wat_dre: {
            name: "Dredger",
            icon: wor_clo_to_wat_dre,
            text: (
                <ul>
                    <ListItem text="All plant and equipment carried on pontoons must be adequately secured." />
                    <ListItem text="The platform must have edge protection and adequate welfare facilities." />
                    <ListItem text="It can only be used in the appropriate tide and weather conditions." />
                </ul>
            )
        },
        wor_clo_to_wat_div: {
            name: "Diving",
            icon: wor_clo_to_wat_div,
            text: (
                <ul>
                    <ListItem text="Only divers that have a commercial qualification and are properly accredited for the works can be used for work activities. They must have a current diving medical certificate." />
                    <ListItem text="The divers equipment must be fully serviced and in good working order and used in accordance with the relevant code of practice" />
                    <Li>
                        <Typography variant="title">
                            On site there must be appropriate controls,
                            including
                        </Typography>
                        <ol>
                            <ListItem text="A dive plan" />
                            <ListItem text="Dive team roles" />
                            <ListItem text="Emergency and rescue plan" />
                            <ListItem text="Full face mask" />
                            <ListItem text="Lifeline" />
                            <ListItem text="Availability of medical oxygen" />
                            <ListItem text="Secondary supply of breathing air" />
                            <ListItem text="Voice communication" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        wor_clo_to_wat_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: wor_clo_to_wat_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
